const sparkleAnimations = [
  { breathe: '4.2s', float: '5.8s', breatheDelay: '0s', floatDelay: '0.3s' },
  { breathe: '3.8s', float: '6.2s', breatheDelay: '1.2s', floatDelay: '0.8s' },
  { breathe: '5.0s', float: '7.0s', breatheDelay: '0.6s', floatDelay: '1.5s' },
  { breathe: '3.5s', float: '5.5s', breatheDelay: '2.0s', floatDelay: '0.1s' },
  { breathe: '4.5s', float: '6.5s', breatheDelay: '0.9s', floatDelay: '2.0s' },
  { breathe: '4.0s', float: '5.2s', breatheDelay: '1.8s', floatDelay: '1.0s' },
  { breathe: '3.7s', float: '6.8s', breatheDelay: '0.3s', floatDelay: '1.6s' },
]

function sparkleStyle(i: number): React.CSSProperties {
  const s = sparkleAnimations[i]
  return {
    animation: `breathe ${s.breathe} ease-in-out infinite, float ${s.float} ease-in-out infinite`,
    animationDelay: `${s.breatheDelay}, ${s.floatDelay}`,
    transformOrigin: '50% 50%',
    transformBox: 'fill-box' as const,
  }
}

export function Sparkles({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 365.681 422.638"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8" filter="url(#sparkles-glow)">
        <g style={sparkleStyle(0)}>
          <path
            d="M17.9114 29.1831C17.1257 30.6064 15.5066 31.2983 14.2951 30.7285C13.0836 30.1587 12.7383 28.5429 13.524 27.1195C14.3097 25.6962 15.9287 25.0043 17.1403 25.5741C18.3518 26.1439 18.697 27.7597 17.9114 29.1831Z"
            fill="#FFFDB6"
            fillOpacity="0.84"
            style={{ mixBlendMode: 'overlay' }}
            shapeRendering="crispEdges"
          />
        </g>
        <g style={sparkleStyle(1)}>
          <path
            d="M268.247 410.565C266.796 413.195 263.805 414.473 261.566 413.42C259.328 412.368 258.69 409.383 260.142 406.753C261.593 404.123 264.584 402.845 266.823 403.898C269.061 404.951 269.699 407.936 268.247 410.565Z"
            fill="#FFFDB6"
            fillOpacity="0.84"
            style={{ mixBlendMode: 'overlay' }}
            shapeRendering="crispEdges"
          />
        </g>
        <g style={sparkleStyle(2)}>
          <path
            d="M21.6752 341.446C19.2561 345.828 14.7587 348.188 11.63 346.717C8.50127 345.245 7.92604 340.499 10.3452 336.117C12.7643 331.734 17.2617 329.374 20.3904 330.846C23.5191 332.317 24.0943 337.063 21.6752 341.446Z"
            fill="#F6F396"
            fillOpacity="0.86"
            style={{ mixBlendMode: 'overlay' }}
            shapeRendering="crispEdges"
          />
        </g>
        <g style={sparkleStyle(3)}>
          <path
            d="M36.9535 11.52C36.4025 12.5183 35.2669 13.0036 34.4172 12.6039C33.5675 12.2043 33.3254 11.0711 33.8764 10.0728C34.4274 9.07454 35.563 8.58926 36.4127 8.98891C37.2624 9.38855 37.5045 10.5218 36.9535 11.52Z"
            fill="#FFFDB6"
            fillOpacity="0.84"
            style={{ mixBlendMode: 'overlay' }}
            shapeRendering="crispEdges"
          />
        </g>
        <g style={sparkleStyle(4)}>
          <path
            d="M239.366 390.668C238.957 391.409 238.114 391.769 237.483 391.472C236.852 391.176 236.673 390.335 237.082 389.594C237.491 388.853 238.334 388.493 238.964 388.789C239.595 389.086 239.775 389.927 239.366 390.668Z"
            fill="#FFFDB6"
            fillOpacity="0.84"
            style={{ mixBlendMode: 'overlay' }}
            shapeRendering="crispEdges"
          />
        </g>
        <g style={sparkleStyle(5)}>
          <path
            d="M326.901 335.727C326.14 337.105 324.573 337.774 323.4 337.223C322.228 336.671 321.894 335.107 322.654 333.729C323.414 332.352 324.982 331.682 326.154 332.234C327.327 332.785 327.661 334.349 326.901 335.727Z"
            fill="#FFFDB6"
            fillOpacity="0.84"
            style={{ mixBlendMode: 'overlay' }}
            shapeRendering="crispEdges"
          />
        </g>
        <g style={sparkleStyle(6)}>
          <path
            d="M356.287 332.579C355.269 334.423 353.171 335.32 351.601 334.581C350.031 333.843 349.584 331.75 350.602 329.905C351.62 328.061 353.718 327.165 355.287 327.903C356.857 328.641 357.305 330.735 356.287 332.579Z"
            fill="#FFFDB6"
            fillOpacity="0.84"
            style={{ mixBlendMode: 'overlay' }}
            shapeRendering="crispEdges"
          />
        </g>
      </g>
      <defs>
        <filter
          id="sparkles-glow"
          x="0"
          y="0"
          width="365.681"
          height="422.638"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4.42446" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.964706 0 0 0 0 0.952941 0 0 0 0 0.588235 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
